import React, { createContext, useCallback, useState, useMemo } from 'react';
import axios from 'axios';
// WAS (backlog #160 öncesi): import {NODE_BACKEND_API_URL, NODE_BACKEND_API_PORT} from "../BackendConstants";
import { JAVA_BACKEND_API_URL, getAuthHeader } from "../BackendConstants";

/**
 * E-posta Kayıtları (mail_log). Backlog #160 (2026-10-10): eski Node uçları ölüydü (404); artık
 * FDS-Backend EmailController, personele açık:
 *   GET /email/logs?page&limit&search → { data, page, limit, total, totalPages } (mesaj gövdesi yok)
 *     #573: &templateKey= tek bir sistem şablonunun postaları (ACTIVATION, FORGOT_PASSWORD, TEST, ...; "-" = şablonsuz serbest postalar),
 *           &failedOnly=true yalnız gitmeyenler (başarısız ya da güvenli modda engellenen; neden `mail_log_error` alanında)
 *   GET /email/logs/{id}              → mail_log_message dahil
 *   GET /email/system-emails/all      → "Kimden" listesi (şifresiz)
 *   GET /email/users/search?search=   → alıcı arama
 * ⚠️ GÖNDERİM YOK: Java backend'de SMTP istemcisi henüz yok. sendEmail ölü /api/send-email'e gitmiyor,
 * false dönüyor; sayfa Mail Gönder'i kapalı gösteriyor.
 */

const EmailLogContext = createContext();

export const EmailLogProvider = ({ children }) => {
    const [systemEmails, setSystemEmails] = useState([]);
    const [emailLogs, setEmailLogs] = useState([]);
    const [loading, setLoading] = useState(true);

    // WAS (backlog #160 öncesi):
    // const api = useMemo(() => ({
    //     emailLogs: `${NODE_BACKEND_API_URL}:${NODE_BACKEND_API_PORT}/api/email-logs`,
    //     systemEmails: `${NODE_BACKEND_API_URL}:${NODE_BACKEND_API_PORT}/api/system-emails`,
    //     sendEmail: `${NODE_BACKEND_API_URL}:${NODE_BACKEND_API_PORT}/api/send-email`
    // }), []);
    const api = useMemo(() => ({
        emailLogs: `${JAVA_BACKEND_API_URL}/email/logs`,
        systemEmails: `${JAVA_BACKEND_API_URL}/email/system-emails/all`,
        userSearch: `${JAVA_BACKEND_API_URL}/email/users/search`,
        sendEmail: null,   // #160: Java'da gönderim ucu yok
    }), []);

    // WAS (until #573): const fetchEmailLogs = useCallback(async (page = 1, limit = 10, search = '') => {
    const fetchEmailLogs = useCallback(async (page = 1, limit = 10, search = '', templateKey = '', failedOnly = false) => {
        setLoading(true);
        try {
            // WAS: const response = await axios.get(api.emailLogs, { params: { page, limit, search } });
            // WAS (until #573): const response = await axios.get(api.emailLogs, { params: { page, limit, search }, headers: getAuthHeader() });
            const params = { page, limit, search };
            if (templateKey) params.templateKey = templateKey;
            if (failedOnly) params.failedOnly = true;
            const response = await axios.get(api.emailLogs, { params, headers: getAuthHeader() });
            console.log("Fetched Email Logs:", response.data);
            setEmailLogs(response.data);
        } catch (error) {
            console.error('Error fetching email logs:', error);
        } finally {
            setLoading(false);
        }
    }, [api]);


    const getEmailLogById = useCallback(async (id) => {
        try {
            // WAS: const response = await axios.get(`${api.emailLogs}/${id}`);
            const response = await axios.get(`${api.emailLogs}/${id}`, { headers: getAuthHeader() });
            return response.data;
        } catch (error) {
            console.error('Error fetching email log detail:', error);
            throw error;
        }
    }, [api]);

    const searchUsers = useCallback(async (searchTerm = "") => { // Default olarak boş bir string veriyoruz
        try {
            // WAS: const response = await axios.get(`${NODE_BACKEND_API_URL}:${NODE_BACKEND_API_PORT}/api/users/search`, { params: { search: searchTerm } });
            if (!searchTerm || searchTerm.trim().length < 2) return [];
            const response = await axios.get(api.userSearch, { params: { search: searchTerm }, headers: getAuthHeader() });
            return response.data || [];
        } catch (error) {
            console.error('Error searching users:', error);
            return [];
        }
    }, [api]);

    const sendEmail = async ({ senderId, userId, recipients, ccRecipients, subject, content }) => {
        console.log("Gönderilen e-posta verileri:", { senderId, userId, recipients, ccRecipients, subject, content });
        // #160: Java backend'de gönderim yok; ölü Node ucuna istek atmıyoruz.
        if (!api.sendEmail) {
            console.warn("E-posta gönderimi henüz Java backend'e taşınmadı (backlog #160).");
            return false;
        }
        
        try {
            const response = await axios.post(api.sendEmail, {
                senderId, // Sistem mail ID
                userId,   // Kullanıcı ID (varsa localStorage'dan alınır)
                recipients,
                ccRecipients,
                subject,
                content
            });
    
            if (response.status === 200) {
                return true;
            }
        } catch (error) {
            console.error("E-posta gönderilirken hata oluştu:", error);
        }
        return false;
    };

    const getSystemEmails = useCallback(async () => {
        try {
            // WAS (backlog #160 öncesi):
            // const systemEmailsURL = `${NODE_BACKEND_API_URL}:${NODE_BACKEND_API_PORT}/api/system-emails`;  // API URL'ini doğrudan burada tanımladık
            // console.log("Fetching system emails from:", systemEmailsURL);  // URL kontrolü için log
            // const response = await axios.get(systemEmailsURL);
            // console.log("Fetched System Emails:", response.data);  // Gelen yanıtı kontrol etmek için log
            const response = await axios.get(api.systemEmails, { headers: getAuthHeader() });
            setSystemEmails(Array.isArray(response.data) ? response.data : []);
        } catch (error) {
            console.error('Error fetching system emails:', error);
        }
    }, [api]);


    return (
        <EmailLogContext.Provider value={{
            emailLogs,
            fetchEmailLogs,
            searchUsers,
            getEmailLogById,
            systemEmails,
            getSystemEmails,
            sendEmail,
            loading
        }}>
            {children}
        </EmailLogContext.Provider>
    );
};

export default EmailLogContext;
